<div [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'">
  <mat-progress-bar
    style='position: absolute; top: 0'
    [class.hidden]='cService.hideIndeterminateProgress'
    color='accent'
    mode='indeterminate'
  ></mat-progress-bar>

  <mat-dialog-content style='overflow: hidden' class='margin-t-10'>
    <div>
      <div fxLayout='row' fxFlex>
        <dialog-sidepane
          *ngIf='rptService.selectedRows.length > 0'
          style='min-height: 750px'
          (onPaneItemSelected)='paneItemSelected($event)'
          (newPaneItemAdded)='newItemAddedToPanel($event)'
          [paneItems]='sidepaneItems'
          [reportEndpointName]='reportEndpointName'
          [isClassicView]='true'
          [selectedRowPin]='dfService.selectedDriver.pin'
          [showCounterBadge]='canViewCoachingToolkitTab'
        ></dialog-sidepane>

        <div fxLayout='column' fxFlex='grow'>
          <!-- Header -->
          <div
            class='drilldown-header'
            [style.background-image]="'url(' + cService.mentorAssetRoot + 'navy-blue-map.png)'"
          >
            <!-- Close Icon Button -->
            <div fxLayout='row' fxLayoutAlign='end'>
              <div
                mat-dialog-close
                class='close-button'
                [style.backgroundColor]="'#' + cService.userProfile.HqColour"
              >
                <mat-icon style='position: relative; top: 7px; left: 7px'>close</mat-icon>
              </div>
            </div>

            <!-- Driver badge -->
            <div fxLayout='row'>
              <div class='medium-badge-holder'>
                <div class='medium-round-badge'>
                  <div style='position: relative; top: 20px; text-align: center; width: inherit'>
                    {{ firstLastNames | namesToInitial }}
                  </div>
                </div>
                <div
                  *ngIf='
										driverIndexSummaryChart &&
										driverIndexSummaryChart.data.indexing_index_value !== undefined &&
										cService.userProfile.userPermissions?.permIndexing === cService.permLevels.view
									'
                  vrmIndexingRatingBg
                  [indexingRatingColor]='driverIndexSummaryChart.data.indexing_rating'
                  class='number-badge'
                  [matTooltip]="'REPORTCOLUMNS.DriverINDEX Score' | translate"
                >
                  <small>{{ driverIndexSummaryChart.data.indexing_index_value }}</small>
                </div>

                <div
                  class='badge-details'
                  style='padding-top: 0; text-align: center'
                  *ngIf='!cService.isPcViewport && cService.userProfile?.companyPermissions'
                >
                  {{
                  cService.userProfile?.companyPermissions.permMisReportUseCdbId ===
                  cService.permLevels.TRUE
                    ? dfService.selectedDriver.cdbId
                    : dfService.selectedDriver.pin
                  }}
                </div>
              </div>

              <div fxLayout='column' fxFlex='grow'>
                <div [fxLayout]="cService.isPcViewport ? 'row' : 'column'">
                  <div class='first-last-names'>
                    {{ firstLastNames }}
                  </div>

                  <div
                    [fxLayout]="cService.isPcViewport ? 'column' : ''"
                    fxFlex
                    *ngIf='dfService.selectedDriver.outstanding'
                  >
                    <span fxFlex *ngIf='cService.isPcViewport'></span>

                    <div
                      *ngIf='canViewCoachingToolkitTab'
                      [fxLayout]="cService.isPcViewport ? 'row' : 'column'"
                      class='header-outstanding-info'
                      [fxLayoutAlign]="cService.isPcViewport ? 'end' : ''"
                      (click)='dfService.currentTabIndex = dfService.drilldownTabs.history.id'
                    >
											<span>
												<small>{{ 'MESSAGESANDWARNINGS.thisDriverHas' | translate }}</small>
												<small class='little-numeric-square-badge'>{{
                          dfService.selectedDriver.outstanding
                          }}</small>
											</span>
                      <small style='padding-top: 2px'>{{
                        'MESSAGESANDWARNINGS.requiredCoachingSessionsOutstanding'
                          | translate
                          | lowercase
                        }}</small>
                    </div>
                  </div>
                </div>

                <div
                  class='badge-details'
                  *ngIf='cService.isPcViewport && cService.userProfile?.companyPermissions'
                >
                  {{
                  cService.userProfile?.companyPermissions.permMisReportUseCdbId ===
                  cService.permLevels.TRUE
                    ? dfService.selectedDriver.cdbId
                    : dfService.selectedDriver.pin
                  }}
                </div>
              </div>
            </div>
          </div>

          <!-- Tabs -->
          <div [fxLayout]="dfService.widenForm || !cService.isLargePcViewport ? 'column' : 'row wrap'" fxFlex>
            <!-- Forms | For instances where form should render to left / top -->
            <div
              *ngIf='dfService.showFormPane && (dfService.widenForm || !cService.isLargePcViewport)'
              fxFlex
              style='margin-bottom: 50px'
            >
              <cross-page-intervention-renderer
                (triggerSave)='submitDynamicForm($event)'
                (triggerMarkFormAsComplete)='formMayNowBeMarkedAsComplete($event)'
              ></cross-page-intervention-renderer>
            </div>

            <div [fxFlex]='dfService.widenForm'></div>

            <mat-tab-group
              #drilldownTabs
              [dynamicHeight]='true'
              class='drilldown-tab-group'
              fxFlex
              [(selectedIndex)]='dfService.currentTabIndex'
              (selectedTabChange)='selectedTabChanged($event)'
            >
              <!-- Insights & Dynamic Form -->
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon
                    class='three-c-grey margin-r-10'
                    [matTooltip]="'GENERIC.insights' | translate"
                  >
                    insert_chart
                  </mat-icon>
                  <span *ngIf='cService.isPcViewport' class='bold'>{{
                    'GENERIC.insights' | translate | uppercase
                    }}</span>
                </ng-template>

                <ng-template matTabContent>
                  <div
                    [fxLayout]="cService.isPcViewport ? 'row' : 'column'"
                    fxLayoutGap='15px'
                    fxFlex
                    class='tab-content-holder'
                  >
                    <!-- Charts -->
                    <div *ngIf='dialogDataReady' fxFlex>
                      <!-- Summary and chart -->
                      <div fxLayout='column' fxFlex='grow'>
                        <!-- Summary -->
                        <vrm-card
                          [cardTitle]="'GENERIC.summary' | translate | uppercase"
                          [shadedHeaderLevel]='17'
                          [paddingBottom]='true'
                          [marginTop]='0'
                          *ngIf='
														cService.userProfile.userPermissions?.permIndexing ===
														cService.permLevels.view
													'
                        >
                          <div class='padding-10'>
                            <mat-chip-list fxLayoutAlign='center'>
                              <mat-chip [disabled]='true'>
                                <h2>
                                  {{
                                  driverIndexSummaryChart.data
                                    .indexing_violations_active
                                  }}
                                </h2>
                                &nbsp;
                                <span>{{ 'FORM.activeEvents' | translate }}</span>
                              </mat-chip>

                              <mat-chip [disabled]='true'>
                                <h2>
                                  {{
                                  driverIndexSummaryChart.data
                                    .indexing_index_value
                                  }}
                                </h2>
                                &nbsp;
                                <span>{{ 'FORM.indexValue' | translate }}</span>
                              </mat-chip>

                              <mat-chip
                                [disabled]='true'
                                class='force'
                                *ngIf='
																	driverIndexSummaryChart.data &&
																	driverIndexSummaryChart.data.indexing_rating
																'
                                [class.black-background]="driverIndexSummaryChart.data.indexing_rating.toLowerCase() === 'black'"
                                [class.red-background]="driverIndexSummaryChart.data.indexing_rating.toLowerCase() === 'red'"
                                [class.amber-background]="driverIndexSummaryChart.data.indexing_rating.toLowerCase() === 'yellow'"
                                [class.green-background]="driverIndexSummaryChart.data.indexing_rating.toLowerCase() === 'green'"
                              >
                                <h2>
                                  {{
                                  driverIndexSummaryChart.data.indexing_rating
                                    | determineElementProps: 'riskLevel'
                                    | uppercase
                                  }}
                                </h2>
                                &nbsp;
                                <span>{{ 'FORM.indexRating' | translate }}</span>
                              </mat-chip>
                            </mat-chip-list>
                          </div>

                          <mat-divider></mat-divider>

                          <div class='padding-10 padding-t-non'>
                            <div style='margin: 0 auto'>
                              <vrm-chart
                                [chartData]='driverIndexSummaryChart.chart'
                              ></vrm-chart>
                            </div>
                          </div>
                        </vrm-card>

                        <!-- Active Event Summary -->
                        <vrm-summary-card
                          *ngIf='
														cService.userProfile.userPermissions?.permIndexing ===
														cService.permLevels.view
													'
                          [cardTitle]="'GENERIC.activeEventSummary' | translate | uppercase"
                          [summaryData]='dfService.selectedDriver.activeEventSummary'
                          [context]="'activeEvents'"
                        ></vrm-summary-card>

                        <!-- Historic Events -->
                        <vrm-summary-card
                          *ngIf='
														cService.userProfile.userPermissions?.permIndexing ===
														cService.permLevels.view
													'
                          [cardTitle]="'GENERIC.historicEvents' | translate | uppercase"
                          [summaryData]='dfService.selectedDriver.historicEventSummary'
                          [context]="'historicEvents'"
                        ></vrm-summary-card>

                        <!-- VRM Modules Summary -->
                        <vrm-training-activity
                          *ngIf='
														cService.userProfile.userPermissions?.permIndexing ===
															cService.permLevels.view &&
														cService.userProfile.companyPermissions
															?.permMisVRMModuleActivity === cService.permLevels.TRUE
													'
                          [cardTitle]="'GENERIC.vrmModules' | translate | uppercase"
                          [driverModules]='dfService.selectedDriver.vrmModulesSummary'
                        ></vrm-training-activity>

                        <!-- VRM Modules History Summary -->
                        <vrm-training-activity
                          *ngIf='
														cService.userProfile.userPermissions?.permIndexing ===
															cService.permLevels.view &&
														cService.userProfile.companyPermissions
															?.permMisVRMModuleActivity === cService.permLevels.TRUE
													'
                          [cardTitle]="'GENERIC.archivedTraining' | translate | uppercase"
                          [driverModules]='dfService.selectedDriver.vrmModulesHistoric'
                        ></vrm-training-activity>

                        <!-- Mentor charts -->
                        <vrm-card
                          cardTitle='MENTOR by eDriving'
                          [shadedHeaderLevel]='17'
                          [paddingBottom]='true'
                          *ngIf='
														cService.userProfile.companyPermissions?.permIsMentor &&
														renderMultipleCharts &&
														cService.userProfile.companyPermissions
															?.permMisMenuMentorVisible === cService.permLevels.TRUE
													'
                        >
                          <div fxLayout='column' fxFlex='grow'>
                            <div
                              class='text-align-c bold three-c-grey padding-t-10 padding-b-10'
                            >
                              {{ 'CHART.ficoScoreRating' | translate | uppercase }}
                            </div>

                            <div fxLayout='row' fxLayoutAlign='space-around'>
                              <div
                                class='padding-5'
                                [style.width.%]="
																	cService.isMobileViewport ? '100' : '45'
																"
                                fxLayout='row wrap'
                                fxLayoutGap='3px'
                                fxLayoutAlign='space-around'
                              >
                                <div
                                  *ngFor='let scoreLabel of cService.ficoScoreRatings'
                                  class='padding-b-10 text-align-c'
                                >
																	<span [class]='scoreLabel.class'>
																		<small>{{ scoreLabel.scoreMargin }}</small>
																		<div>
																			<small class='bold'>{{
                                        scoreLabel.rating | uppercase
                                        }}</small>
																		</div>
																	</span>
                                </div>
                              </div>
                            </div>

                            <mat-divider></mat-divider>

                            <div
                              fxLayout='row wrap'
                              fxLayoutAlign='space-between'
                              [fxLayoutGap]="cService.isMobileViewport ? '' : '3px'"
                              class='padding-r-10'
                            >
                              <div
                                *ngFor='let chart of mentorCharts'
                                [style.width.%]="
																	cService.isMobileViewport ||
																	chart.options.title.text
																		.toLowerCase()
																		.includes('fico')
																		? '100'
																		: '45'
																"
                              >
                                <vrm-chart [chartData]='chart'></vrm-chart>
                              </div>
                            </div>
                          </div>
                        </vrm-card>

                        <!-- Mentor Playlist -->
                        <vrm-summary-card
                          *ngIf='
														cService.userProfile.userPermissions?.permIndexing ===
															cService.permLevels.view &&
														cService.userProfile.companyPermissions
															?.permMisMentorPlaylist === cService.permLevels.TRUE
													'
                          [cardTitle]="'GENERIC.mentorPlaylist' | translate | uppercase"
                          [mentorSummaryData]='dfService.selectedDriver.mentorPlaylistSummary'
                          [driverModules]='dfService.selectedDriver.mentorPlaylistModules'
                          [context]="'mentorPlaylistModules'"
                        >
                        </vrm-summary-card>

                        <vrm-mentor-rewards-summary
                          *ngIf='canViewMentorRewardsSummary'
                          [cardTitle]="cService.getSingleTranslation('MAINSIDENAV.mentorRewards', 'Mentor Rewards') | uppercase"
                          [rewardsData]='dfService.selectedDriver.mentorRewards'>
                        </vrm-mentor-rewards-summary>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </mat-tab>

              <!-- Coaching Toolkit / History -->
              <mat-tab *ngIf='canViewCoachingToolkitTab'>
                <ng-template mat-tab-label>
                  <mat-icon
                    class='three-c-grey margin-r-10'
                    [matTooltip]="'GENERIC.coachingToolkit' | translate"
                  >
                    school
                  </mat-icon>
                  <span *ngIf='cService.isPcViewport' class='bold'>{{
                    'GENERIC.coachingToolkit' | translate | uppercase
                    }}</span>

                  <counter-badge
                    [counter]='dfService.selectedDriver.outstanding'
                    style='padding-left: 5px'
                    *ngIf='dfService.selectedDriver.outstanding'
                  ></counter-badge>
                </ng-template>

                <ng-template matTabContent>
                  <div class='tab-content-holder' fxLayout='column'>
                    <!-- Intervention launcher button -->
                    <div fxLayout='row' fxLayoutAlign='end'>
                      <button
                        type='button'
                        *ngIf='!hasSingleIntervention && canCreateAdHocIntervention'
                        [disabled]='!canCreateAnIntervention'
                        [mat-menu-trigger-for]='availableInterventionMenu'
                        mat-flat-button
                        vrm-bg-color
                      >
                        {{ 'GENERIC.createNewCoachingSession' | translate | uppercase }}
                        <mat-icon style='position: relative; top: -1px; left: 8px'
                        >arrow_drop_down
                        </mat-icon
                        >
                      </button>

                      <!-- Single Intervention launcher button -->
                      <button
                        type='button'
                        *ngIf='hasSingleIntervention && canCreateAdHocIntervention'
                        [disabled]='
													!canCreateAnIntervention ||
													hasPendingSingleIntervention ||
													!singleIntervention.allowUserCreation
												'
                        [mat-menu-trigger-for]='renderWithOnlyPccCrashOptions'
                        (click)='
													isPccReview
														? null
														: dfService.launchSelectedIntervention(
																null,
																singleIntervention?.value
														  )
												'
                        mat-flat-button
                        vrm-bg-color
                      >
                        {{ singleInterventionButtonText | translate | uppercase }}
                        <mat-icon
                          *ngIf='isPccReview'
                          style='position: relative; top: -1px; left: 8px'
                        >arrow_drop_down
                        </mat-icon
                        >
                      </button>

                      <mat-menu #availableInterventionMenu='matMenu' [overlapTrigger]='false'>
                        <ng-container
                          *ngFor='let intervention of applicableCoachingInterventions'
                        >
                          <button
                            *ngIf='
															intervention.value.toLowerCase() !==
																dfService.pccReviewInterventionValue.toLowerCase() ||
																!intervention.allowUserCreation;
															else renderWithPccCrashOptions
														'
                            type='button'
                            mat-menu-item
                            [disabled]='!intervention.allowUserCreation'
                            (click)='
															dfService.launchSelectedIntervention(
																null,
																intervention?.value
															)
														'
                          >
                            {{
                            cService.readyTranslations.form[intervention.name]
                              ? cService.readyTranslations.form[intervention.name]
                              : intervention.name
                            }}
                          </button>

                          <ng-template #renderWithPccCrashOptions>
                            <button
                              type='button'
                              mat-menu-item
                              [disabled]='!intervention.allowUserCreation'
                              [mat-menu-trigger-for]='availableCrashMenu'
                            >
                              {{
                              cService.readyTranslations.form[intervention.name]
                                ? cService.readyTranslations.form[intervention.name]
                                : intervention.name
                              }}
                            </button>
                            <mat-menu
                              #availableCrashMenu='matMenu'
                              [overlapTrigger]='false'
                            >
                              <button
                                type='button'
                                mat-menu-item
                                [disabled]='true'
                                class='bold'
                              >
																<span *ngIf='pccReviewCrashes.length > 0'>{{
                                  'GENERIC.availableCrashes' | translate
                                  }}</span>
                                <span *ngIf='pccReviewCrashes.length <= 0'>{{
                                  'GENERIC.noCrashFound' | translate
                                  }}</span>
                              </button>
                              <button
                                type='button'
                                mat-menu-item
                                *ngFor='let crash of pccReviewCrashes'
                                (click)="
																	dfService.launchSelectedIntervention(
																		null,
																		intervention?.value,
																		'',
																		crash
																	)
																"
                                [matTooltip]='crash.description'
                              >
                                {{ crash.description }}
                              </button>
                            </mat-menu>
                          </ng-template>
                        </ng-container>
                      </mat-menu>

                      <mat-menu #renderWithOnlyPccCrashOptions='matMenu' [overlapTrigger]='false'>
                        <ng-container *ngIf='isPccReview'>
                          <button mat-menu-item [disabled]='true'>
														<span *ngIf='pccReviewCrashes.length > 0'>{{
                              'GENERIC.availableCrashes' | translate
                              }}</span>
                            <span *ngIf='pccReviewCrashes.length <= 0'>{{
                              'GENERIC.noCrashFound' | translate
                              }}</span>
                          </button>
                          <button
                            mat-menu-item
                            *ngFor='let crash of pccReviewCrashes'
                            (click)="
															dfService.launchSelectedIntervention(
																null,
																singleIntervention?.value,
																'',
																crash
															)
														"
                            [matTooltip]='crash.description'
                          >
                            {{ crash.description }}
                          </button>
                        </ng-container>
                      </mat-menu>
                    </div>

                    <div class='report-container'>
                      <!-- History report grid | Note: this doesn't show dialog
                      it only uses the showDialog event to launch the form -->
                      <vrm-casual-report
                        fxFlex
                        *ngIf='coachingHistoryMeta'
                        [metadata]='coachingHistoryMeta'
                        [rawData]='coachingHistory'
                        [otherOptions]='reportOptions'
                        (showDialog)='
													dfService.launchSelectedIntervention($event.data.selectedRow)
												'
                      ></vrm-casual-report>
                    </div>
                  </div>
                </ng-template>
              </mat-tab>
            </mat-tab-group>

            <!-- Forms | For instances where form should render to right / bottom -->
            <div
              *ngIf='dfService.showFormPane && !dfService.widenForm && cService.isLargePcViewport'
              [fxFlex]="!cService.isPcViewport ? '' : '40'"
            >
              <cross-page-intervention-renderer
                (triggerSave)='submitDynamicForm($event)'
                (triggerMarkFormAsComplete)='formMayNowBeMarkedAsComplete($event)'
              ></cross-page-intervention-renderer>
            </div>
          </div>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>
    <div fxLayout='row' fxLayoutAlign='end'>
      <button type='button' mat-button mat-dialog-close class='sharp-corners bold'>
        {{ 'GENERIC.close' | translate | uppercase }}
      </button>
    </div>
  </mat-dialog-content>
</div>
